import { apiGetAuth, apiPostAuth } from '@/utils/api'
import { API_CORE } from '@/utils/api-url'
import { invalidateCoreMappingCache } from '@/utils/core-mapping-cache'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  valid_user_list: {
    isLoading: false,
    data: false
  },
  is_loading: false,
  log_sync_list: {
    isLoading: false,
    data: {}
  },
  log_core_list: {
    isLoading: false,
    data: {}
  },
  core_sync_progress_list: {
    isLoading: false,
    data: {}
  },
  toggle_modal_add_edit_discard: {
    targetModals: false,  
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loading: false,
    loadingPopUp: false
  },
  meta_filter: {
    order_by: 'updated_at',
    sort_by: 'desc'
  }
}

const mutations = {
  "SET_VALID_USER_LIST": (state, payload) => {
    state.valid_user_list = payload
  },
  "SET_IS_LOADING": (state, payload) => {
    state.is_loading = payload
  },
  "SET_LOG_SYNC_LIST": (state, payload) => {
    state.log_sync_list = payload
  },
  "SET_LOG_CORE_LIST": (state, payload) => {
    state.log_core_list = payload
  },
  "SET_CORE_SYNC_PROGRESS_LIST": (state, payload) => {
    state.core_sync_progress_list = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  },
  "SET_META_FILTER": (state, payload) => {
    state.meta_filter = payload
  }
}

const actions = {
  async getValidUserList(context) {
    try {
      context.commit('SET_VALID_USER_LIST', { isLoading: true })
      const response = await apiGetAuth(API_CORE.VALID_USER_LIST)
      const users = (response.data?.data || []).map(item => ({
        id: item.UserName,
        name: item.UserName,
        username: item.UserName
      }))
      context.commit('SET_VALID_USER_LIST', {
        isLoading: false,
        data: { data: users }
      })
    } catch (error) {
      context.commit('SET_VALID_USER_LIST', { isLoading: false, data: false })
      notificationDanger(error)
    }
  },
  async getLogSyncList(context, payload) {
    context.commit('SET_LOG_SYNC_LIST', { isLoading: true })
    try {
      const response = await apiGetAuth(API_CORE.SYNC_LOG_LIST, payload)
      context.commit('SET_LOG_SYNC_LIST', { 
        isLoading: false,
        data: response?.data
      })
    } catch(err) {
      context.commit('SET_LOG_SYNC_LIST', {
        isLoading: false,
        data: {}
      })
      notificationDanger(err)
    }
  },
  async getCoreSyncProgressList(context, payload) {
    context.commit('SET_CORE_SYNC_PROGRESS_LIST', { isLoading: true })
    try {
      const response = await apiGetAuth(API_CORE.LOG_SYNC_LIST, payload)
      context.commit('SET_CORE_SYNC_PROGRESS_LIST', {
        isLoading: false,
        data: response?.data
      })
    } catch(err) {
      context.commit('SET_CORE_SYNC_PROGRESS_LIST', {
        isLoading: false,
        data: {}
      })
      notificationDanger(err)
    }
  },
  async getSyncCoreDetail(context, id) {
    try {
      const response = await apiGetAuth(API_CORE.SYNC_DETAIL(id))
      return response?.data?.data || null
    } catch (err) {
      notificationDanger(err)
      return null
    }
  },
  // Tab "Log API Core" (tabel log_sync_core) di menu /admin/log-sync
  async getLogCoreList(context, payload) {
    context.commit('SET_LOG_CORE_LIST', { isLoading: true })
    try {
      const response = await apiGetAuth(API_CORE.SYNC_LOG_CORE_LIST, payload)
      context.commit('SET_LOG_CORE_LIST', {
        isLoading: false,
        data: response?.data
      })
    } catch(err) {
      context.commit('SET_LOG_CORE_LIST', {
        isLoading: false,
        data: {}
      })
      notificationDanger(err)
    }
  },
  async getLogCoreDetail(context, id) {
    try {
      const response = await apiGetAuth(API_CORE.SYNC_LOG_CORE_DETAIL(id))
      return response?.data?.data || null
    } catch (err) {
      notificationDanger(err)
      return null
    }
  },
  async getSyncLogDetail(context, id) {
    try {
      const response = await apiGetAuth(API_CORE.SYNC_LOG_DETAIL(id))
      return response?.data?.data || null
    } catch (err) {
      notificationDanger(err)
      return null
    }
  },
  async syncCoreRetryLog(context, payload) {
    context.commit('SET_IS_LOADING', true)
    try {
      const isObject = typeof payload === 'object' && payload !== null
      const id = isObject ? payload.id : payload
      const body = isObject && payload.request ? { request: payload.request } : undefined
      const response = await apiPostAuth(API_CORE.SYNC_LOG_RETRY(id), body)
      invalidateCoreMappingCache()
      context.commit('SET_IS_LOADING', false)
      return response
    } catch (err) {
      context.commit('SET_IS_LOADING', false)
      throw err
    }
  },
  async syncCoreRetryProgress(context, payload) {
    context.commit('SET_IS_LOADING', true)
    try {
      const isObject = typeof payload === 'object' && payload !== null
      const id = isObject ? payload.id : payload
      const body = isObject && payload.request ? { request: payload.request } : undefined
      const response = await apiPostAuth(API_CORE.SYNC_RETRY(id), body)
      invalidateCoreMappingCache()
      context.commit('SET_IS_LOADING', false)
      return response
    } catch (err) {
      context.commit('SET_IS_LOADING', false)
      throw err
    }
  },
  async syncCoreCompany(context, payload) {
    context.commit('SET_IS_LOADING', true)
    try {
      const response = await apiPostAuth(API_CORE.SYNC_COMPANY, payload, 180000)
      invalidateCoreMappingCache()
      context.commit('SET_IS_LOADING', false)
      return response
    } catch (err) {
      context.commit('SET_IS_LOADING', false)
      throw err
    }
  },
  async syncCoreMutationInvoice(context, payload) {
    context.commit('SET_IS_LOADING', true)
    try {
      const response = await apiPostAuth(API_CORE.SYNC_INVOICE, payload, 180000)
      context.commit('SET_IS_LOADING', false)
      return response
    } catch (err) {
      context.commit('SET_IS_LOADING', false)
      throw err
    }
  },
  async syncCoreJournal(context, payload) {
    context.commit('SET_IS_LOADING', true)
    try {
      const response = await apiPostAuth(API_CORE.SYNC_JOURNAL, payload, 180000)
      context.commit('SET_IS_LOADING', false)
      return response
    } catch (err) {
      context.commit('SET_IS_LOADING', false)
      throw err
    }
  },
  async generateParticipant(context, payload) {
    context.commit('SET_IS_LOADING', true)
    try {
      const response = await apiPostAuth(API_CORE.GENERATE_PARTICIPANT, payload, 180000)
      context.commit('SET_IS_LOADING', false)
      return response
    } catch (err) {
      context.commit('SET_IS_LOADING', false)
      throw err
    }
  }
}

const getters = {
  get_valid_user_list: state => state.valid_user_list,
  get_is_loading: state => {
    return state.is_loading
  },
  get_log_sync_list: state => {
    return state.log_sync_list
  },
  get_log_core_list: state => {
    return state.log_core_list
  },
  get_core_sync_progress_list: state => {
    return state.core_sync_progress_list
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  },
  meta_filter: state => {
    return state.meta_filter
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
